// extracted by mini-css-extract-plugin
export default {"dedi_plan_table":"dedicated-grpc_dedi_plan_table__pDmWf","text_left":"dedicated-grpc_text_left__9uw5O"};